/* unplugin-vue-components disabled */import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'PikerDate',
  props: /*#__PURE__*/_mergeModels({
    data: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["confirm-calendar"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      data = _toRefs.data;
    var emit = __emit;
    var model = _useModel(__props, "modelValue");
    var calendarRef = ref();
    var defaultDate = computed(function () {
      return data.value.startTime.toDate();
    });
    function onConfirm(value) {
      model.value = false;
      var dayjsValue = dayjs(value);
      emit('confirm-calendar', dayjsValue);
    }
    function onClosed() {
      calendarRef.value && calendarRef.value.reset();
    }
    return function (_ctx, _cache) {
      var _component_van_calendar = _resolveComponent("van-calendar");
      return _openBlock(), _createBlock(_component_van_calendar, {
        "row-height": 60,
        ref_key: "calendarRef",
        ref: calendarRef,
        "show-mark": false,
        onClosed: onClosed,
        onConfirm: onConfirm,
        "switch-mode": "month",
        show: model.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return model.value = $event;
        }),
        "max-date": new Date(),
        "default-date": _unref(defaultDate),
        style: {
          height: '555px'
        }
      }, null, 8, ["show", "max-date", "default-date"]);
    };
  }
});